<template>
  <!-- 传智教育品牌实力数据展示 -->
  <div class="box14">
    <img
      class="box14__title"
      src="../../../assets/coursePage/llm/box14/title.png"
      alt="传智教育·A股上市教育品牌"
    />

    <div class="stats-grid">
      <div
        class="stats-row"
        v-for="(row, rowIndex) in statsList"
        :key="rowIndex"
      >
        <div
          class="stats-item"
          v-for="(item, index) in row"
          :key="index"
          :class="{ 'stats-item--divider': index < row.length - 1 }"
        >
          <p class="stats-item__num">
            <span class="stats-item__value">{{ item.value }}</span>
            <span class="stats-item__unit">{{ item.unit }}</span>
          </p>
          <p class="stats-item__label">{{ item.label }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statsList: [
        [
          { value: "30", unit: "万", label: "学员验证" },
          { value: "70", unit: "%", label: "口碑推荐率" },
          { value: "90", unit: "+", label: "专职技术大牛" },
        ],
        [
          { value: "800", unit: "+", label: "严选教学团队" },
          { value: "1200", unit: "+", label: "深度合作企业" },
          { value: "2000", unit: "+", label: "业内企业资源共享" },
        ],
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box14 {
  position: relative;
  padding: 88px 32px 48px;
  width: 100%;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/llm/box14/bg.png") no-repeat top
    center;
  background-size: 100% auto;
  background-color: #f3f6ff;

  &__title {
    display: block;
    width: 588px;
    max-width: 100%;
    height: 48px;
    margin: 0 auto;
    object-fit: contain;
  }

  .stats-grid {
    position: relative;
    z-index: 1;
    margin-top: 48px;
  }

  .stats-row {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    min-height: 114px;
    margin-bottom:20px;
    & + & {
      margin-top: 20px;
    }
  }
  .stats-row:last-child{
      margin-bottom:0;
  }
  .stats-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-align: center;

    &--divider {
      position: relative;

      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 2px;
        height: 100%;
        background: linear-gradient(
          180deg,
          rgba(200, 210, 230, 0) 0%,
          rgba(200, 210, 230, 0.8) 50%,
          rgba(200, 210, 230, 0) 100%
        );
      }
    }

    &__num {
      margin: 0;
      line-height: 60px;
      white-space: nowrap;
    }

    &__value {
      font-family: PingFangSC, PingFang SC;
      font-size: 48px;
      font-weight: 500;
      color: #00245a;
    }

    &__unit {
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 500;
      color: #00245a;
    }

    &__label {
      margin: 2px 0 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      font-weight: 400;
      color: #5d708d;
      line-height: 36px;
    }
  }
}
</style>
